<div class="ly-sp-s-bottom">
  <div class="accordion" [id]="getId()">
    <div id="padre">

      <input type="checkbox" [id]="this.idDefault" class="accordion__input" (change)="this.changeCollapsed();"
        [checked]="getCollapsible()">
      <div [attr.for]="this.idDefault" style="display: flex;justify-content: space-between; cursor: pointer;"
        onclick="this.changeCollapsed()">
        <div [attr.for]="this.idDefault" class="accordion__label bs-h2 th-text-main ">
          <label [attr.for]="this.idDefault" class="accordion__label bs-h2 th-text-main "
            style="margin-top: 2px">{{getTitle()}}</label>
          <label [attr.for]="this.idDefault"
            class="accordion__label bs-paragraph th-text-gray-paragraphs">{{getDescription()}}</label>
        </div>
        <label [attr.for]="this.idDefault" class="accordion__label bs-h2 th-text-main center-items"
          onclick="this.changeCollapsed()">
          <i class="media-style pr-4 pl-4  bs-button th-text-main additionalInformation-web">{{getAdditionalInformation()}}
          </i>

          <img _ngcontent-tam-c113="" src="assets/imgs/Open-radio.png"
            class="{{this.isCollapsed ?  'filter-btn-img':'display-none' }}" style="    margin-right: 5px;">
          <img _ngcontent-tam-c113="" src="assets/imgs/Close-radio.png"
            class="{{this.isCollapsed ?  'display-none':'filter-btn-img' }}" style="    margin-right: 5px;">
        </label>
      </div>
      <div [attr.for]="this.idDefault" style="display: flex;justify-content: space-between;">
        <div [attr.for]="this.idDefault" class=" bs-h2 th-text-main  additionalInformationLabel ">
          <i class="media-style pr-4 pl-4  bs-button th-text-main ">{{getAdditionalInformation()}}
          </i>
        </div>

      </div>

      <div class="accordion__content">
        <ng-container #target></ng-container>

      </div>
      <div id="icon">
        <span class="btn-card-label ">
          <i [class]="getIcon()+' media-style pr-4 pl-4 th-text-border'"></i>
        </span>
      </div>
    </div>
  </div>


</div>